/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_REBATE_PROGRAMS = 'GET_ALL_REBATE_PROGRAMS';
export const SET_REQ_RECORD_MAILING_DATA = 'SET_REQ_RECORD_MAILING_DATA';
export const GET_MANUFACTURERS_BY_PQR = 'GET_MANUFACTURERS_BY_PQR';
export const INVOICE_FREEZE_RES = 'INVOICE_FREEZE_RES';
export const SET_DEFAULT_QTR = 'SET_DEFAULT_QTR';
export const SET_ERROR_MSG = 'SET_ERROR_MSG';
export const RESET_FREEZEINVOICE_STORE_FREEZE_INV =
  'RESET_FREEZEINVOICE_STORE_FREEZE_INV';
